import { createPortal } from 'react-dom';
import type { MutableRefObject } from 'react';
import { useCallback, useEffect, useState } from 'react';
import produce from 'immer';
import YearGroup from './YearGroup';

type TypeYearPickerImplProps = {
  hookRef: MutableRefObject<null>;
  value?: YearValue;
  onChange?: (value: YearValue) => void;
};

type YearValue = {
  yearRepeat:
    | {
        startAt: string;
        endAt: string;
      }[]
    | undefined;
};

function defaultValue(): YearValue {
  return {
    yearRepeat: [],
  };
}

function TypeYearPickerImpl(props: TypeYearPickerImplProps) {
  const { hookRef, value, onChange } = props;
  const [innerValue, setInnerValue] = useState(value || defaultValue());

  useEffect(() => {
    onChange?.(innerValue);
  }, [innerValue, onChange]);
  const handleChange = useCallback((value) => {
    setInnerValue(
      produce((draft) => {
        draft.yearRepeat = value;
      }),
    );
  }, []);

  if (!hookRef.current) {
    return null;
  }

  return (
    <>
      {createPortal(
        <YearGroup value={innerValue.yearRepeat} onChange={handleChange} />,
        hookRef.current!,
      )}
    </>
  );
}

export default TypeYearPickerImpl;
